module.exports = __webpack_public_path__ + "img/weather_adj.bd28424c.png";